import { render, staticRenderFns } from "./AdditionalInputDiscount.vue?vue&type=template&id=61e208c8"
import script from "./AdditionalInputDiscount.vue?vue&type=script&lang=js"
export * from "./AdditionalInputDiscount.vue?vue&type=script&lang=js"
import style0 from "./AdditionalInputDiscount.vue?vue&type=style&index=0&id=61e208c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports